<fl-froala-editor
  id="froala-editor"
  [froalaEditor]="froalaHelper.rtd"
  [(froalaModel)]="form.sections[0].elements[0].element_object.raw_html"
  *ngIf="!advancedRichTextEditor; else advancedEditor"
></fl-froala-editor>
<ng-template #advancedEditor>
  <ace
    [(value)]="form.sections[0].elements[0].element_object.raw_html"
    [mode]="'html'"
    [theme]="'tomorrow'"
  ></ace>
</ng-template>
